import React__default from "react";
import { useId } from "@floating-ui/react";
import { UI } from "react-day-picker";
import { GridColumn } from "../../grid/grid-column/grid-column.mjs";
import { Select } from "../select/select.mjs";
function Dropdown(props) {
  const { options: propOptions, className, classNames, value, onChange: propOnChange, "aria-label": label, disabled } = props;
  const options = propOptions;
  const onChange = propOnChange;
  const cssClassSelect = [classNames[UI.Dropdown], className].join(" ");
  const id = useId();
  const availableOptions = options.filter((o) => !o.disabled);
  const shouldRenderStaticText = availableOptions.length === 1;
  return /* @__PURE__ */ React__default.createElement(GridColumn, { width: ["xs"], className: classNames[UI.DropdownRoot] }, shouldRenderStaticText ? /* @__PURE__ */ React__default.createElement("div", { className: "text-small text-bold" }, capitalizeFirstLetter(availableOptions[0].label)) : /* @__PURE__ */ React__default.createElement(
    Select,
    {
      id,
      simpleValue: true,
      label,
      hideLabel: "no-break",
      className: cssClassSelect,
      size: "small",
      value: value.toString(),
      disabled,
      options: options.map((o) => {
        return {
          label: capitalizeFirstLetter(o.label),
          value: o.value.toString(),
          isDisabled: o.disabled
        };
      }),
      onChange: (nextValue) => {
        if (nextValue) {
          onChange({
            target: {
              value: nextValue
            }
          });
        }
      }
    }
  ));
}
function capitalizeFirstLetter(str) {
  return str[0].toUpperCase() + str.slice(1);
}
export {
  Dropdown
};
